import { ComponentType, useContext } from 'react'
import { RoomTypes } from '@weblite/ts-action/room'
import { SearchedPvListItemWithStatus } from '$common/room-list-search/searched-user-list-item-with-status'
import { SearchedHallListItemWithStatus } from '$common/room-list-search/searched-hall-list-item-with-status'
import { SearchedWappRoomListItemWithStatus } from '$common/room-list-search/searched-wapp-room-list-item-with-status'
import { SearchedPrivateSpaceListItemWithStatus } from '$common/room-list-search/searched-private-space-list-item-with-status'
import { useRoom } from '$logic/room/react-hook'
import { nothing } from '$func/utils'
import { SearchQueryContext } from '$comp/_app/components/leftPanel/components/chat-list-search/chat-list-search'

interface Props {
  roomId: string
  onClick?: () => unknown
}

interface ComponentProps {
  roomId: string
  onClick: () => unknown
  searchQuery: string
}

const componentMapper: Record<RoomTypes, ComponentType<ComponentProps>> = {
  CHANNEL: SearchedHallListItemWithStatus,
  GROUP: SearchedHallListItemWithStatus,
  PV: SearchedPvListItemWithStatus,
  WAPP_ROOM: SearchedWappRoomListItemWithStatus,
  PRIVATE_SPACE: SearchedPrivateSpaceListItemWithStatus,
}

export function SearchedRoomListItemWithStatus({
  roomId,
  onClick = nothing,
}: Props) {
  const room = useRoom(roomId)

  const searchQuery = useContext(SearchQueryContext)

  if (!room) return null

  const Component = componentMapper[room?.type]

  return (
    <Component roomId={roomId} onClick={onClick} searchQuery={searchQuery} />
  )
}
